import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexesDataPvoComponent } from './indexes-data-pvo.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: IndexesDataPvoComponent,
        data: {
          title: "Ma\'lumotlar",
          breadcrumb: "Ma\'lumotlar"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndexesDataPvoRoutingModule { }
